import * as React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AppBar from './components/AppBar/AppBar';
import Footer from './components/Footer/Footer';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import SamplesBeacon from './pages/beacon-page/SamplesBeacon';
import NotFound from './pages/NotFound';
import { RecoilRoot } from 'recoil';

export default function App() {
    return (
        <RecoilRoot>
            <BrowserRouter>
                <div className="Site" >
                    <img src={process.env.PUBLIC_URL + "/assets/images/prototype.png"}
                        style={{ width: "10em", position: "fixed", right: 0, top: 0 }}
                        alt="This application is a prototype" />
                    <AppBar />
                    <div className="Site-content">
                        <Routes>
                            {/* <Route path='beacon_enod/' element={<Navigate replace to="/beacon_enod/About" />} /> */}
                            {/* <Route path='beacon_enod/about' element={<AboutPage />} /> */}
                            <Route path={process.env.PUBLIC_URL} element={<SamplesBeacon />} />
                            <Route path='*' element={<NotFound></NotFound>}></Route>
                        </Routes>
                    </div>
                    <Footer />
                </div>
            </BrowserRouter >
        </RecoilRoot>
    );
}
